module.exports = __webpack_public_path__ + "img/photo-28.47b09005.webp";